// extracted by mini-css-extract-plugin
export default {"modalOverlay":"GC-z","modalContent":"HC-z","header":"IC-z","close":"JC-z"};